import React, {useState, useEffect} from 'react'
import GPS        from './GPS'
import FMRadio    from './FMRadio'
import CBRadio    from './CBRadio'
import CellPhone  from './CellPhone'
import Wheel      from './Wheel'

export default function Cab(props) {
  // const [hazardsOn, setHazardsOn] = useState(false);
  //const [windowsDown, setWindowsDown] = useState(false);
  const [directionsLooked, setDirectionsLooked] = useState([]);
  //const [fmRadioOn, setFmRadioOn] = useState(false);
  //const [cbRadioOn, setCbRadioOn] = useState(false);

  useEffect(() => {
    props.audioController.playAudioByName('truck_engine');
    props.audioController.setWindowVolumeInitial();
    return () => props.audioController.removeAudio('truck_engine');
  }, []);

  useEffect(() => {
    if (props.crossingOver) {
      props.audioController.removeAudio('truck_engine');
    } else {
      setTimeout(() =>
      {
        props.audioController.setWindowVolumeInitial();
      }
      , 10)
    }
  }, [props.crossingOver])

  // useEffect(() => {
  //   //we're going to set the score for anything that needs to happen after road is clear 
  //   console.log("props.roadClear" , props.roadClear);  
  //   console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!props.inZone" , props.inZone);

  //   //is the window down while crossing?
  //   if (props.roadClear && windowsDown && props.inZone ){
  //     props.setScore('windowsDown', props.data.tripId, props.data.crossingId);      
  //   } 
  //   //is the radio on while crossing?
  //   if (props.roadClear && fmRadioOn && props.inZone) {  
  //     props.setScore('radioNotDistraction', props.data.tripId, props.data.crossingId);
  //   } 
  //   //is the cbradio on while crossing?
  //   if (props.roadClear && cbRadioOn && props.inZone) {     
  //     props.setScore('cbNotDistraction', props.data.tripId, props.data.crossingId);  
  //   }

  // },[props.roadClear, props.inZone])

  const onLookOver = (e, direction) => {
    props.setView(direction);
    props.setLookOverMouseDown(true);  
    console.log("props.roadClear" , props.roadClear);
    console.log("props.intersectionIndex" , props.intersectionIndex);
    if (props.roadClear && props.intersectionIndex === -1 && !props.directionsLooked.includes(direction)) {
      const newDirectionsLooked = [...props.directionsLooked];
      newDirectionsLooked.push(direction);
      props.setDirectionsLooked(newDirectionsLooked);
    } else if (props.roadClear && props.intersectionIndex > -1 && !props.directionsLooked.includes(`${direction}-${props.intersectionIndex}`)) {
      const newDirectionsLooked = [...props.directionsLooked];
      newDirectionsLooked.push(`${direction}-${props.intersectionIndex}`);
      props.setDirectionsLooked(newDirectionsLooked);
    }
  }

  const handleHazardsClick = () => {
    //setHazardsOn(!hazardsOn);
    //props.setScore('turnedOnHazards');
    props.setHazardsOn(!props.hazardsOn);    
  }

  const handleWindowsClick = () => {    
    // if (props.roadClear && !windowsDown && props.inZone ){
    //   props.setScore('windowsDown', true);
    // }  
    console.log("props.windowsDown" , props.windowsDown);  
    props.setWindowsDown(!props.windowsDown);
    props.audioController.toggleWindowVolume();
  }

  const handleFMRadioClick = () => { 
    // if (props.roadClear && (typeof props.data.fmRadio === 'object') && fmRadioOn) {   
    //   console.log("RADIO WAS ON IN INTERSECTION" );    
    //   props.setScore('radioNotDistraction');
    // }     
    props.setFmRadioOn(!props.fmRadioOn)   
  }

  const handleCBClick = () => { 
    // if (props.roadClear && (typeof props.data.cbRadio === 'object') && cbRadioOn) {     
    //   props.setScore('cbNotDistraction');   
    // }
    props.setCbRadioOn(!props.cbRadioOn)
  }

  return (
    <div className={`Cab`}>
      <div className={`bg ${props.view}`} />
      <FMRadio data={props.data.fmRadio || {}} audioController={props.audioController} view={props.view} crossingOver={props.crossingOver} setScore={props.setScore} onPower={handleFMRadioClick}  />
      <CBRadio data={props.data.cbRadio || {}} audioController={props.audioController} view={props.view} crossingOver={props.crossingOver} setScore={props.setScore} onPower={handleCBClick} />
      <CellPhone data={props.data.cellphone || {}} audioController={props.audioController} view={props.view} crossingOver={props.crossingOver} setScore={props.setScore} />    
      {props.view === 'default' && (
        <> 
          <button className={`look left ${!props.showLookArrows ? 'disabled' : ''}`} onMouseDown={e => onLookOver(e, 'left')} />
          <button className={`look right ${!props.showLookArrows ? 'disabled' : ''}`} onMouseDown={e => onLookOver(e, 'right')} />
          <GPS />
          <Wheel speed={props.speed} distanceFromCrossing={props?.distanceFromCrossing}/>
          <div className={`hazards ${props.hazardsOn ? 'on' : 'off'}`} onClick={handleHazardsClick} />
          <div className={`windows-button ${props.windowsDown ? 'on' : 'off'}`} onClick={handleWindowsClick} />

          {props.intersectionIndex > -1 && (
            <>
              <button className={`turn-right `} onClick={() => props.turn('right', props.intersectionIndex)} />
              <button className={`turn-left `} onClick={() => props.turn('left', props.intersectionIndex)} />
            </>
          )}
        </>
      )}
    </div>
  )

}


